export const CurrencyCodeConst: any = [
    { CountryCode: 'jp', CurrencyCode: 'JPY' },
    { CountryCode: 'en', CurrencyCode: 'GBP' },
    { CountryCode: 'vn', CurrencyCode: 'VND' },
];

export const rgxKanaFullW = /^([ァ-ン]|[０-９]|ー|\s)+$/;
export const rgxKanaHalfW = /^([ｧ-ﾝﾞﾟ])+$/;
export const QueryParams: any = {
    HtOrgCode: 'htorgcode',
    UserId: 'userid',
    ConsulId: 'consulid',
    Time: 't',
    RsvDate: 'date',
    RsvNum: 'num',
    Mode: 'mode',
    ConsulDay: 'consulday',
    ConsulNum: 'consulnum',
    DateOfBirth: 'dateofbirth',
    PReissueKey: 'PReissueKey',
    Mail: 'Mail',
    IsQR: 'isqr',
    SulID: 'sulid'
};


